import {XauditModel} from '../xaudit.model';

export class ToothSurfaceConfigurationModel extends XauditModel {
  ToothSurfaceId: string;
  ToothId: string;
  SegmentOrder: number;
  enumToothSurfaceID: string;
  Geometry3D: string;
  GeometryTriangleIndices: string;

  ToothSurfaceDescription: string;
  isSaved: boolean = true;
  isDelete: boolean = false;
}
